import WebsiteConfigs from 'website_configs/website_configs'

const COOKIE_CATEGORY = 'marketing'
const SESSION_ORGANIC_PARAMS_KEY = 'organic'

const searchEngines = [
  'google.',
  'bing.com',
  'duckduckgo.com',
  'yahoo.com',
  'baidu.com',
  'yandex.'
]

const flagValue = '1'

class OrganicFlag {
  static save () {
    if (WebsiteConfigs.displayCookiesConsent && window.orejime && window.orejime.internals.manager.consents[COOKIE_CATEGORY] !== true) {
      return
    }

    const referrer = document.referrer
    if (!referrer) {
      return
    }

    const refUrl = new URL(referrer)
    const host = refUrl.hostname.toLowerCase()

    let isOrganic = false
    for (const engine of searchEngines) {
      if (host.includes(engine)) {
        isOrganic = true
        break
      }
    }

    if (isOrganic) {
      sessionStorage.setItem(SESSION_ORGANIC_PARAMS_KEY, flagValue)
    }
  }

  static isOrganic () {
    return sessionStorage.getItem(SESSION_ORGANIC_PARAMS_KEY) === flagValue
  }
}

export default OrganicFlag
